

import { useTranslation } from "react-i18next";
import ReactDOM from 'react-dom/client';

import { Link as LinkScroll, animateScroll as scroll, scroller } from "react-scroll";

import React, { useState, useEffect, useRef } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation,
    useNavigate
} from "react-router-dom";

import UserApi from "../../../../services/UserApi.jsx";
import { separatorNumber, useGlobalFunc } from "../../../../global/constants.js";
import { Pagination } from "@mui/material";
import Tag from "../../../../compontents/Tag.js";






// import homeshadowImg from '../../../assets/homeshadow.png'
// import homescrollImg from '../../../assets/homescroll.png'

// import homepic1Img from '../../../assets/homepic1.png'
// import homepic2Img from '../../../assets/homepic2.png'


const Home = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate()
    const query = new URLSearchParams(location.search);


    const { setLoading, successToast, errorToast } = useGlobalFunc()
    const [totalPage, setTotalPage] = useState(1);

    const [data, setData] = useState(null)

    async function getData(id) {
        setLoading(true)
        try {
            let res = await UserApi.orderGet({ id: id })
            console.log(res.data.data)
            setData(res.data.data)

        }
        catch (errors) {
            errorToast(errors?.response?.data?.message || errors.toString())
        }
        setLoading(false)
    }

    useEffect(() => {
        let id = location.pathname.substring(location.pathname.lastIndexOf('/') + 1)
        getData(id)
    }, []);

    return <div className="mt-8 text-black96  relative  w-full px-4 sm:px-10 py-5 sm:py-7 bg-white border-solid border border-black06 rounded-[20px]">
        <div className="text-lg font-bold mb-4">訂單明細</div>
        {data &&
            <div>
                <div className="mb-4 flex gap-4 items-center flex-wrap">
                    <div className=" font-bold text-sm">訂單編號 #{data.orderTradeNo}</div>
                    <div className="flex gap-4 ">
                        <div className={`${data.paymentStatus == 'paid' ? 'bg-green-100 text-green-500' : 'bg-red-100 text-red-500'} font-bold text-xs p-2  rounded  ont-bold `}>{t(`orderPaymentStatus.${data.paymentStatus}`)}</div>
                        <div className={`${data.shipStatus == 'delivered' ? 'bg-green-100 text-green-500' : 'bg-red-100 text-red-500'} font-bold text-xs p-2  rounded  ont-bold `}>{t(`orderShipStatus.${data.shipStatus}`)}</div>
                    </div>

                </div>
                <div className="   whitespace-nowrap w-full  overflow-x-auto pb-10">
                    <table className="w-full text-sm" >
                        <thead className="">

                            <tr className="  text-black96 bg-black02 text-xs font-semibold ">
                                <th className="">商品名稱</th>
                                <th className="">商品價格</th>
                                <th className="">商品數量</th>
                                <th className="">小計</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                data && data.products.map(i => <tr key={i.id} className="align-top text-black9 font-semibold ">
                                    <td className="">{i.product.name}
                                        <div className="flex flex-wrap gap-2 items-center mt-1">
                                            {
                                                !i.product.isDiscount &&
                                                <Tag className="" title="不打折" />
                                            }
                                            {
                                                i.product.isShoppingPointPackage &&
                                                <Tag className="" title="購物金商品" />
                                            }
                                        </div></td>
                                    <td className="">${separatorNumber(i.product.price)}</td>
                                    <td className="">{separatorNumber(i.quantity)}</td>
                                    <td className="">${separatorNumber(i.total)}</td>

                                </tr>
                                )
                            }

                        </tbody>
                    </table>



                </div>


                <div className="mt-8 text-black96  relative  w-full px-4 sm:px-8 py-3 sm:py-5 bg-white border-solid border border-black06 rounded-[20px]">
                    <div className="text-base font-bold mb-4">訂單金額</div>
                    {/* <div className="flex justify-between text-sm mb-2">
                        <p>訂單運費</p>
                        <p className=" font-bold">$45</p>
                    </div> */}
                    <div className="flex justify-between text-sm mb-2">
                        <p>總商品小計</p>
                        <p className=" font-bold">${separatorNumber(data.totalProductPrice)}</p>
                    </div>
                    {
                        data.useShoppingPoints > 0 &&
                        <div className="flex justify-between text-sm mb-2">
                            <p>購物金折抵</p>
                            <p className=" font-bold">${separatorNumber(data.useShoppingPoints)}</p>
                        </div>
                    }
                    {
                        data.discountRatio > 0 &&
                        <div className="flex justify-between text-sm mb-2">
                            <p>身份折扣</p>
                            <p className=" font-bold">{t(`grade.${data.identity}`)}折扣: {Number(data.discountRatio) / 10}折</p>
                        </div>
                    }
                    <div className="bg-black06 w-full h-px mb-2"></div>
                    <div className="flex justify-between text-sm ">
                        <p>訂單總額</p>
                        <p className=" font-bold">${separatorNumber(data.totalPrice)}</p>
                    </div>
                </div>
                <div className="mt-8 text-black96  relative  w-full px-4 sm:px-8 py-3 sm:py-5 bg-white border-solid border border-black06 rounded-[20px]">
                    <div className="text-base font-bold mb-4">寄送資訊</div>
                    <div className="flex justify-between text-sm mb-2">
                        <p>寄送方式</p>
                        <p className=" font-bold">{t(`${data.shipMethod}`)}</p>
                    </div>
                    <div className="flex justify-between text-sm mb-2">
                        <p>收件人</p>
                        <p className=" font-bold">{data.contact.recipientName}</p>
                    </div>
                    <div className="flex justify-between text-sm mb-2">
                        <p>聯絡電話</p>
                        <p className=" font-bold">+886 {data.contact.recipientPhone}</p>
                    </div>
                    {
                        data.contact.recipientAddress &&
                        < div className="flex justify-between text-sm mb-2">
                            <p>收貨地址</p>
                            <p className=" font-bold">{data.contact.recipientAddress}</p>
                        </div>
                    }
                </div>

                <div className="mt-8 text-black96  relative  w-full px-4 sm:px-8 py-3 sm:py-5 bg-white border-solid border border-black06 rounded-[20px]">
                    <div className="text-base font-bold mb-4">發票</div>
                    <div className="flex justify-between text-sm mb-2">
                        <p>方式</p>
                        <p className=" font-bold">{t(`${data.invoice.type}`)}</p>
                    </div>

                    {
                        data.invoice.type == 'company' &&
                        < div className="flex justify-between text-sm mb-2">
                            <p>公司統編</p>
                            <p className=" font-bold">{data.invoice.name} {data.invoice.number}</p>
                        </div>
                    }
                </div>

                <div className="mt-8 text-black96  relative  w-full px-4 sm:px-8 py-3 sm:py-5 bg-white border-solid border border-black06 rounded-[20px]">
                    <div className="text-base font-bold mb-4">進階資訊</div>
                    <div className="flex justify-between text-sm mb-2">
                        <p>購買時的身份</p>
                        <p className=" font-bold">{t(`grade.${data.identity}`)}</p>
                    </div>
                    <div className="flex justify-between text-sm mb-2">
                        <p>符合進階條件</p>
                        <p className=" font-bold">{t(`${data.isUpgrade}`)}</p>
                    </div>
                    {
                        data.isUpgrade && <>
                            <div className="flex justify-between text-sm mb-2">
                                <p>進階成為</p>
                                <p className=" font-bold">{t(`grade.${data.upgradeTo}`)}</p>
                            </div>
                            <div className="flex justify-between text-sm mb-2">
                                <p>進階意願</p>
                                <p className=" font-bold">{t(`${data.upgradeWillingness}`)}</p>
                            </div>
                        </>
                    }


                </div>

            </div>
        }



    </div >

}

export default Home